import { getPublicBaseUrl } from './site';

export function getPocQrPageUrl({ photoUrl, targetUrl, embed = true, autogen = true }) {
  const base = `${getPublicBaseUrl()}/qr-generator-poc`;
  const params = new URLSearchParams();

  if (targetUrl) {
    params.set('url', targetUrl);
  }

  if (photoUrl) {
    const resolvedPhoto = photoUrl.startsWith('http')
      ? photoUrl
      : `${getPublicBaseUrl()}${photoUrl}`;
    params.set('photo', resolvedPhoto);
  }

  if (embed) {
    params.set('embed', '1');
  }

  if (autogen) {
    params.set('autogen', '1');
  }

  return `${base}?${params.toString()}`;
}
